import React, { useState, useEffect } from 'react'
import { Page, Card, Button } from '@shopify/polaris';
import { useDispatch, useSelector } from 'react-redux';
import actionTypes from '../../../store/actionTypes';
import ModalComponent from '../../ModalComponent';
import Loader from '../../Loader';
import ReceiveStock from '../ReceiveStock';
import './style.css'
import axios from 'axios';

const Summary = props => {
    const { saveSummaryOrders, savePurchaseOrders } = actionTypes

    const { receivedQty, itemStatus, purchaseOrders } = useSelector(state => state.POReducer)
    const dispatch = useDispatch()

    const { serverLink, shopId } = useSelector(state => state.ConfigReducer)

    useEffect(() => {
        return () => dispatch({ type: saveSummaryOrders, payload: [] })
    }, [])

    const [StockReceive, setStockReceive] = useState({ active: false, product: {} })
    const [Compeleting, setCompeleting] = useState(false)

    const updateOrderStatus = index => {
        const id = props.summaryOrders[index].id
        const ifConnected = window.navigator.onLine;
        if (ifConnected) {
            const options = {
                method: 'put',
                url: `${serverLink}/order/statusUpdate/${id}/${shopId}`,
            }
            axios(options)
                .then(({ data }) => {
                    console.log('data', data);
                    const pos = purchaseOrders
                    for (const i in pos) {
                        if (pos[i].id === id) {
                            pos[i].status = data
                        }
                    }
                    console.log(pos);
                    dispatch({ type: savePurchaseOrders, payload: pos })

                })
                .catch(error => {
                    console.log("error", error)
                    alert(error)
                })
        } else {
            alert("Please, Check Your Internet Connection!")
        }
    }

    const updateReceivedQty = (id, qty, receivedQty) => {
        const ifConnected = window.navigator.onLine;
        if (ifConnected) {
            setCompeleting(true)
            const receiveData = { receivedQty, status: '' }
            if (qty === receivedQty) {
                receiveData.status = 'full'
            } else if (receivedQty < qty && receivedQty > 0) {
                receiveData.status = 'part'
            }
            const options = {
                method: 'put',
                url: `${serverLink}/order/${id}`,
                data: receiveData
            }
            axios(options)
                .then(({ data }) => {
                    setCompeleting(false)
                    if (data) {
                        let poIndex;
                        let itemIndex;
                        for (const i in props.summaryOrders) {
                            const order = props.summaryOrders[i]
                            for (const j in order.purchaseorderitems) {
                                if (order.purchaseorderitems[j].id === id) {
                                    poIndex = i
                                    itemIndex = j
                                }
                            }
                        }

                        const pos = purchaseOrders
                        for (const orderIndex in pos) {
                            if (pos[orderIndex].id === props.summaryOrders[poIndex].id) {
                                const order = pos[orderIndex]
                                for (const poItemIndex in order.purchaseorderitems) {
                                    if (order.purchaseorderitems[poItemIndex].id === props.summaryOrders[poIndex].purchaseorderitems[itemIndex].id) {
                                        const item = order.purchaseorderitems[poItemIndex]
                                        item.status = receiveData.status
                                        order.purchaseorderitems.splice(poItemIndex, 1, item);
                                    }
                                }
                                pos.splice(orderIndex, 1, order);
                            }
                        }
                        dispatch({ type: savePurchaseOrders, payload: pos })

                        props.summaryOrders[poIndex].purchaseorderitems[itemIndex].status = itemStatus[receiveData.status];
                        if (qty === receivedQty) {
                            props.summaryOrders[poIndex].purchaseorderitems.splice(itemIndex, 1);
                        } else if (receivedQty < qty && receivedQty > 0) {
                            props.summaryOrders[poIndex].purchaseorderitems[itemIndex].received = receivedQty;
                        }
                        dispatch({ type: saveSummaryOrders, payload: props.summaryOrders })

                        updateOrderStatus(poIndex)

                        setStockReceive({ active: false, product: {} })
                    }
                })
                .catch(error => {
                    setStockReceive({ active: false, product: {} })
                    setCompeleting(false)
                    console.log("error", error)
                    alert(error)
                })
        } else {
            alert("Please, Check Your Internet Connection!")
        }
    }

    let rows = [];
    let counter = 0;
    const summaryProducts = []
    for (const order of props.summaryOrders) {
        for (const item of order.purchaseorderitems) {
            counter++;
            const createdDate = new Date(order.createdAt)
            order.createdAt = `${createdDate.toDateString()} ${createdDate.getHours()}:${createdDate.getMinutes()}`
            const row = <tr key={counter} className="tr">
                <td className="td">{counter}</td>
                <td className="td">{order.id}</td>
                <td className="td"><span style={{ display: 'inline-block', maxWidth: '300px', whiteSpace: 'normal' }}>{item.description}</span></td>
                <td className="td">{item.orderNumber}</td>
                <td className="td">{item.notes}</td>
                <td className="td">{item.qty}</td>
                <td className="td">{item.received}</td>
                <td className="td">{order.createdAt}</td>
                <td className="td" style={{ textAlign: 'center' }}>
                    <Button outline onClick={() => setStockReceive({ active: true, product: { ...item, poNum: order.id, vendor: order.vendor } })}>Receive Stock</Button>
                </td>
            </tr >
            summaryProducts.push(row)
        }
        rows = [...rows, summaryProducts]
    }
    const loaderStyle = {
        width: "20px",
        height: "20px",
        borderWidth: "4px",
        borderStyle: "double solid solid",
        borderColor: "white",
    }
    return (
        <Page
            fullWidth
            title={`Purchase Order - Summary for ${props.summaryOrders[0].vendor.name}`}
            primaryAction={{
                content: 'Back',
                onAction: () => dispatch({ type: saveSummaryOrders, payload: [] }),
            }}
        >
            <Card
                subdued
            >
                <Card.Section>
                    <div className='tableParent'>
                        <table className="summaryTable">
                            <thead className="summaryTableHead">
                                <tr>
                                    <th className="th">#</th>
                                    <th className="th">PO #</th>
                                    <th className="th">Name</th>
                                    <th className="th">For Order</th>
                                    <th className="th">Notes</th>
                                    <th className="th">Qty.</th>
                                    <th className="th">Received</th>
                                    <th className="th">Ordered At</th>
                                    <th className="th" style={{ textAlign: 'center' }}>Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    rows
                                }
                            </tbody>
                        </table>
                    </div>
                </Card.Section>
            </Card>
            <ModalComponent
                large={false}
                modalTitle={`Receive Purchase Order Line #${StockReceive.product.id}`}
                active={StockReceive.active}
                handleClose={() => setStockReceive({ active: false, product: {} })}
                primaryAction={{
                    content: Compeleting ? <Loader style={loaderStyle} /> : 'Complete Line',
                    onAction: () => updateReceivedQty(StockReceive.product.id, StockReceive.product.qty, receivedQty)
                }}
                secondaryActions={{
                    content: 'Cancel',
                    onAction: () => setStockReceive({ active: false, product: {} }),
                    destructive: true
                }}
                component={<ReceiveStock product={StockReceive.product} />}
            />
        </Page >
    )
}

export default Summary
